import { gql } from '@apollo/client';

export const getCheckoutHealthOffer = gql`query checkoutHealthOffer($offerId: String!) {
  health {
    checkoutHealthOffer(offerId: $offerId) {
      _id
      publicSoId
      status
      brandId
      publicOfferId
      supplementary {
        label
        actionLabel
        brandName
        brandCode
        priceChangeModifier {
          amount
          type
          description
        }
        voucherPriceModifier{
          amount
        }
        voucherPriceChangeModifier{
          amount
          type
          description
          code
        }
        numberOfInstallments
        code
        visual {
          highlight
          tooltip
          description
        }
        logoUrl
        fixedCoverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        coverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        discounts {
          value
          tooltip
        }
        paymentSlipInfo {
          amount
          numOfInstallments
        }
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
        includedInPrice {
          label
          description
        }
        additionalCoverages {
          label
          description
        }
      }
      additional {
        label
        brandName
        brandCode
        priceChangeModifier {
          amount
          type
          description
        }
        voucherPriceModifier{
          amount
        }
        numberOfInstallments
        code
        visual {
          highlight
          tooltip
          description
        }
        logoUrl
        coverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        fixedCoverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        discounts {
          value
          tooltip
        }
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
        includedInPrice {
          label
          description
        }
        additionalCoverages {
          label
          description
        }
      }
      total {
        generalTransfer
        generalTransferWithInstallments
        creditCard
        creditCardWithInstallments
      }
      annotations
    },
    checkoutHealthOfferData(offerId: $offerId) {
      karenca
      newPolicyStartDate
      newPolicyStartDateNote
      productCode
      insuredPerson {
        firstName {
          value
          isEditable
        }
        lastName {
          value
          isEditable
        }
        birthDate {
          value
          isEditable
        }
        gender {
          value
          isEditable
        }
        streetAndHouseNumber {
          value
          isEditable
        }
        street {
          value
          isEditable
        }
        streetKompareId {
          value
          isEditable
        }
        houseNumber {
          value
          isEditable
        }
        city {
          value
          isEditable
        }
        cityKompareId {
          value
          isEditable
        }
        zipCode {
          value
          isEditable
        }
        oib {
          value
          isEditable
        }
        insuranceNumber {
          value
          isEditable
        }
        personalIdNumber {
          value
          isEditable
        }
        personalIdIssuer {
          value
          isEditable
        }
        partnerContactEmail {
          value
          isEditable
        }
      }
      contractor {
        personType
        isSamePerson
        person {
          firstName {
            value
            isEditable
          }
          lastName {
            value
            isEditable
          }
          birthDate {
            value
            isEditable
          }
          gender {
            value
            isEditable
          }
          streetAndHouseNumber {
            value
            isEditable
          }
          street {
            value
            isEditable
          }
          houseNumber {
            value
            isEditable
          }
          streetKompareId {
            value
            isEditable
          }
          city {
            value
            isEditable
          }
          cityKompareId {
            value
            isEditable
          }
          zipCode {
            value
            isEditable
          }
          oib {
            value
            isEditable
          }
          partnerContactEmail {
            value
            isEditable
          }
        }
        company {
          streetAndHouseNumber {
            value
            isEditable
          }
          street {
            value
            isEditable
          }
          houseNumber {
            value
            isEditable
          }
          streetKompareId {
            value
            isEditable
          }
          oib {
            value
            isEditable
          }
          city {
            value
            isEditable
          }
          cityKompareId {
            value
            isEditable
          }
          companyName {
            value
            isEditable
          }
          zipCode {
            value
            isEditable
          }
          partnerContactEmail {
            value
            isEditable
          }
        }
      }
      delivery {
        asEntity {
          value
          isEditable
        }
        name {
          value
          isEditable
        }
        streetAndHouseNumber {
          value
          isEditable
        }
        street {
          value
          isEditable
        }
        streetKompareId {
          value
          isEditable
        }
        houseNumber {
          value
          isEditable
        }
        city {
          value
          isEditable
        }
        cityKompareId {
          value
          isEditable
        }
        zipCode {
          value
          isEditable
        }
      }
    },
    checkoutHealthOfferDocuments(offerId: $offerId) {
      src
      title
    }
  }
}
`;